// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import { Group } from '@mantine/core';
import type { CustomInnerHeaderProps } from 'ag-grid-react';

import { InfoIcon } from 'components/Mantine/InfoIcon';

const resolveHeaderTooltip = <T, C>({ column, displayName, api, context }: CustomInnerHeaderProps<T, C>): ReactNode => {
  const colDef = column.getColDef();
  const { headerTooltip } = colDef;
  if (typeof headerTooltip === 'boolean') return null;
  if (typeof headerTooltip === 'function') {
    return headerTooltip({
      location: 'header',
      colDef,
      column,
      value: displayName,
      valueFormatted: displayName,
      api,
      context,
    });
  }
  return headerTooltip;
};

export const HeaderWithTooltip = <T, C>(props: CustomInnerHeaderProps<T, C>) => (
  <Group gap="xs">
    <span>{props.displayName}</span>
    <InfoIcon label={resolveHeaderTooltip(props)} color="inherit" />
  </Group>
);
